import { render, staticRenderFns } from "./myEmail.vue?vue&type=template&id=36e760a0&scoped=true"
import script from "./myEmail.vue?vue&type=script&lang=js"
export * from "./myEmail.vue?vue&type=script&lang=js"
import style0 from "./myEmail.vue?vue&type=style&index=0&id=36e760a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e760a0",
  null
  
)

export default component.exports